import { render, staticRenderFns } from "./MaterialStatsCard.vue?vue&type=template&id=e897d8d2&"
import script from "./MaterialStatsCard.vue?vue&type=script&lang=js&"
export * from "./MaterialStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialStatsCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VDivider,VIcon})
